export default "__VITE_ASSET__SWIGyw6N__"